import React from "react";
import {Card, CardActionArea, CardContent, CardMedia, Grid, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import categoryReportsPreview from "../assets/reports/category-reports.svg";
import incomeVsExpensePreview from "../assets/reports/income-vs-expense.svg";
import cashFlowPreview from "../assets/reports/cash-flow.svg";
import {useTranslation} from "react-i18next";

const ReportsPage = () => {
    const {t} = useTranslation();
    const reports = [
        {
            id: "bar-chart",
            title: t("pages.reports.cards.categories.title"),
            description: t("pages.reports.cards.categories.description"),
            preview: categoryReportsPreview,
            link: "/reports/categories"
        },
        {
            id: "income-vs-expense",
            title: t("pages.reports.cards.incomeVsExpense.title"),
            description: t("pages.reports.cards.incomeVsExpense.description"),
            preview: incomeVsExpensePreview,
            link: "/reports/income-vs-expense"
        },
        {
            id: "cash-flow",
            title: t("pages.reports.cards.cashFlow.title"),
            description: t("pages.reports.cards.cashFlow.description"),
            preview: cashFlowPreview,
            link: "/reports/cash-flow"
        }
    ];
    return (
        <PageLayout title={t("pages.reports.title")}>
            <CardContent sx={{minHeight: 200, maxHeight: "90%", overflowY: "auto"}}>
                <Grid container spacing={2}>
                    {reports.map((report) => (
                        <Grid item xs={12} sm={6} md={4} key={report.title}>
                            <Card sx={{height: "100%"}}>
                                <CardActionArea
                                    component={RouterLink}
                                    to={report.link ?? `/reports?report=${report.id}`}
                                >
                                    <CardMedia
                                        component="img"
                                        height="160"
                                        image={report.preview}
                                        alt={`${report.title} preview`}
                                    />
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            {report.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {report.description}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </PageLayout>
    );
};

export default ReportsPage;
